import PropTypes from 'prop-types';

import Container, { ContainerProps as MuiContainerProps } from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import { Link, useNavigate } from 'react-router-dom';
import Helmet from '../../components/Helmet';
import { Box, Typography } from '@mui/material';
import { ArrowRightIcon } from '@classity-edtech/ui-base/dist/components/Displays';
import { DashboardLayout } from '../../layouts';
import { windowExists } from '@classity-edtech/ui-base';
import { webPaths } from '../../routes/paths';
import { useGetProfileQuery } from '../../services/profile';
import { useGetMyProfileQuery } from '../../services/users';
import PendingState from '../../components/PendingState';
import { globalColours } from '@classity-edtech/ui-base/dist/style/source';

export interface AdminTutorsProps extends MuiContainerProps {}

export const AdminTutors = ({ className }: AdminTutorsProps) => {
  const navigate = useNavigate();

  const { data: user } = useGetMyProfileQuery();

  const { data: profile } = useGetProfileQuery(
    {
      userId: user.id,
    },
    { skip: !user.id },
  );

  const handleLogout = () => {
    (windowExists as any)?.localStorage.removeItem('token');
    navigate(`${webPaths.root}`);
  };

  return (
    <>
      <Helmet />

      <DashboardLayout
        profileDropdown={{
          memberId: profile?.ids?.find(u => u?.name === 'uid')?.value,
          logoutAction: handleLogout,
        }}
      >
        <Link
          to={`/${webPaths.adminDashboard}`}
          style={{ textDecoration: 'none', width: 'fit-content', cursor: 'pointer' }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: 3,
              items: 'center',
              color: globalColours['$global-colour-content-primary'],
              cursor: 'pointer',
            }}
          >
            <ArrowRightIcon
              sx={{ width: '32px', height: '32px', transform: 'rotate(180deg)', mt: '-4px' }}
            />
            <Typography variant='subtitle3'>Tutors</Typography>
          </Box>
        </Link>
        <PendingState />
      </DashboardLayout>
    </>
  );
};

AdminTutors.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

AdminTutors.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(AdminTutors)(
  ({ theme }) => `
`,
);
